module.exports = require('./helpers/bundle-url').getBundleURL('1DydH') + "logo.c51670a8.svg";